import(/* webpackMode: "eager" */ "/usr/src/app/ia-portal/src/app/[lang]/error.tsx")